// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-body[data-v-4d0de516] {\n  padding: 35px;\n}\nsmall[data-v-4d0de516] {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
